import React from "react";
import { useSelector } from "react-redux";
import SchoolImageSection from "./schoolImageSection/SchoolImageSection";
import SchoolLogoSection from "./schoolLogoSection/SchoolLogoSection";
import Card from "../../../shared/components/ui/card/Card";
import classes from "./LogoAndImagePage.module.css";

const LogoAndImagePage = () => {
    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.Page}>
            <div className={classes.PageHeader}>
                <h1 className={classes.PageTitle}>{texts.logoAndImage}</h1>
                <p className={classes.PageSubtitle}>{texts.schoolImageSubtitle}</p>
            </div>
            <hr className={classes.Divider} />
            <Card>
                <SchoolImageSection />
            </Card>
            <Card>
                <SchoolLogoSection />
            </Card>
        </div>
    );
};

export default LogoAndImagePage;
